
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FloodingSummaryQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"geometry"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GeoJSONGeometryInput"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surfaceFloodCategories"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surfaceFloodClimateCategories"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"surfaceFloodCoverage"},"name":{"kind":"Name","value":"designationsAreaByGeometry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"geometry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"geometry"}}},{"kind":"Argument","name":{"kind":"Name","value":"subCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surfaceFloodCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceStatuses"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"adopted","block":false}]}},{"kind":"Argument","name":{"kind":"Name","value":"cropOverlap"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category_coverage_area"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category_coverage_percentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sub_category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"display_name"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"surfaceFloodClimateCoverage"},"name":{"kind":"Name","value":"designationsAreaByGeometry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"geometry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"geometry"}}},{"kind":"Argument","name":{"kind":"Name","value":"subCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surfaceFloodClimateCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceStatuses"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"adopted","block":false}]}},{"kind":"Argument","name":{"kind":"Name","value":"cropOverlap"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category_coverage_area"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category_coverage_percentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sub_category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"display_name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":719}};
    doc.loc.source = {"body":"query FloodingSummaryQuery(\n  $geometry: GeoJSONGeometryInput!\n  $surfaceFloodCategories: [String]!\n  $surfaceFloodClimateCategories: [String]!\n) {\n  surfaceFloodCoverage: designationsAreaByGeometry(\n    geometry: $geometry\n    subCategories: $surfaceFloodCategories\n    sourceStatuses: [\"adopted\"]\n    cropOverlap: true\n  ) {\n    category_coverage_area\n    category_coverage_percentage\n    sub_category\n    display_name\n  }\n\n  surfaceFloodClimateCoverage: designationsAreaByGeometry(\n    geometry: $geometry\n    subCategories: $surfaceFloodClimateCategories\n    sourceStatuses: [\"adopted\"]\n    cropOverlap: true\n  ) {\n    category_coverage_area\n    category_coverage_percentage\n    sub_category\n    display_name\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["FloodingSummaryQuery"] = oneQuery(doc, "FloodingSummaryQuery");
        
